import React from "react";
import {localField} from "../../../../_ae/helpers/UIHelper";
import {fetchTeamsForSelect, useTeamsForSelect} from "../../../../redux/teams";
import {AEAutocompleteField} from "../../../../_metronic/_partials/controls/forms/AEField";
import {useDispatch} from "react-redux";

export const Field = ({...props}) => {
  const dispatch = useDispatch();
  const {data, metadata, isLoading} = useTeamsForSelect()

  const HandleSearch = search => {
    dispatch(
      fetchTeamsForSelect({
        ...metadata,
        filters: {
          ...metadata.filters,
          search
        }
      })
    )
  }

  return (
    <AEAutocompleteField
      name='team'
      label={'TEAM'}
      options={data}
      getOptionLabel={role=>role[localField()]}
      onOpen={()=>{
        HandleSearch('')
      }}
      onInputChange={(event, search) => {
        HandleSearch(search)
      }}
      loading={isLoading}
      withFeedbackLabel={false}
      customFeedbackLabel={false}
      {...props}
    />
  )
}